import React from 'react'

interface IcFlaggedProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcFlagged: React.FC<IcFlaggedProps> = ({
  width = '16px',
  height = '16px',
  color = '#FD4C45',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.39999 4.8C2.39999 3.47452 3.47451 2.4 4.79999 2.4H12.8C13.103 2.4 13.38 2.5712 13.5155 2.84223C13.651 3.11326 13.6218 3.43759 13.44 3.68L11.4 6.4L13.44 9.12C13.6218 9.36242 13.651 9.68675 13.5155 9.95777C13.38 10.2288 13.103 10.4 12.8 10.4H4.79999C4.35817 10.4 3.99999 10.7582 3.99999 11.2V13.6C3.99999 14.0418 3.64182 14.4 3.19999 14.4C2.75817 14.4 2.39999 14.0418 2.39999 13.6V4.8Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcFlagged
